import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

class ProductThumbImageErrorHandlerForm extends FormBase {
    public getEventTarget(event: Event): Element | null {
        return this.fromEventTarget(event, Element);
    }

    public getThumb(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.POST_PRODUCT_THUMB}"]`, HTMLElement);
    }

    public getImages(root: ParentNode = document): HTMLImageElement[] {
        return this.queryElements(root, `[data-role="${Roles.POST_PRODUCT_THUMB}"] img`, HTMLImageElement);
    }

    public getPlaceholder(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POST_PRODUCT_THUMB_PLACEHOLDER}"]`, HTMLElement);
    }

    public getCategoryId(thumb: HTMLElement): string | null {
        const value = thumb.dataset.categoryId;
        return value && value !== "" ? value : null;
    }

    /** Whether the category icon sprite (rendered once in layouts/app.blade.php) defines this <symbol> id. */
    public hasCategoryIconSymbol(symbolId: string): boolean {
        // <symbol> is an SVGElement, not an HTMLElement — DomQuery.queryElement()
        // defaults to accepting only HTMLElement/HTMLFormElement, so the expected
        // class must be passed explicitly or a real match is silently rejected.
        return this.queryElement(document, `#${symbolId}`, SVGElement) !== null;
    }
}

export { ProductThumbImageErrorHandlerForm };
